import React from 'react';
import Button from '@components/atoms/button';

import { textButton } from './text-button.module.scss';

const TextButton = ({ h1, h2, btnText, onBtnClick }) => {
  return (
    <div className={textButton}>
      <h1>{h1}</h1>
      <h2>{h2}</h2>
      <Button btnText={btnText} onBtnClick={onBtnClick} />
    </div>
  );
};

export default TextButton;
